import React from 'react';
import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';
import { Store } from './pages/Store';
import { Admin } from './pages/Admin';
import { Settings, ShoppingCart } from 'lucide-react';

function App() {
  return (
    <BrowserRouter>
      <div className="min-h-screen bg-gray-100">
        <div className="bg-white shadow-sm">
          <div className="max-w-7xl mx-auto px-4 py-4">
            <div className="flex justify-between items-center">
              <Link to="/">
                <img 
                  src="https://img.adminteam.work/lecmg.png"
                  alt="LEC Digital Design"
                  className="h-16 w-auto"
                />
              </Link>
              <div className="flex gap-4">
                <Link 
                  to="/admin" 
                  className="flex items-center gap-2 text-gray-600 hover:text-gray-900"
                >
                  <Settings size={20} />
                  <span>Admin</span>
                </Link>
                <Link 
                  to="/" 
                  className="flex items-center gap-2 text-gray-600 hover:text-gray-900"
                >
                  <ShoppingCart size={20} />
                  <span>Store</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
        
        <Routes>
          <Route path="/" element={<Store />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;